const MOBILE_BREAK_POINT = 640;

const scrollToSection = (id) => {
  const element = document.getElementById(id);
  const position = element.offsetTop;
  const innerWidth = window.innerWidth;
  const gap = innerWidth >  MOBILE_BREAK_POINT ? 90 : 60;
  if (element) {
    setTimeout(() => {
      window.scrollTo({ top: position - gap, behavior: "smooth" });
    }, 100)
  }
};

function groupMessagesByUID(data) {
  const grouped = {};

  data.forEach(item => {
    const clientID = item.client_id;
    if (!grouped[clientID]) {
      grouped[clientID] = [];
    }
    grouped[clientID].push({
      message: item.message,
      ip: item.ip,
      useragent: item.useragent,
      updated_at: item.updated_at,
      type: item.use,
    });
  });

  return Object.keys(grouped).map(clientID => {
    const messages = grouped[clientID];
    const firstMessage = messages[0] || {};

    // Find the earliest updated_at
    const begin_time = messages.reduce((earliest, msg) => {
      const msgTime = new Date(msg.updated_at).getTime();
      return msgTime < earliest ? msgTime : earliest;
    }, new Date(messages[0].updated_at).getTime());

    return {
      clientID,
      ip: firstMessage.ip,
      useragent: firstMessage.useragent,
      begin_time: new Date(begin_time).toISOString(), // or your desired format
      messages,
    };
  });
}


const preprocessMarkdown = (markdown, disableImage = false) => {
    // Nếu không có markdown link ảnh thì trả về luôn
    if (!/\[[^\]]+\]\((https?:\/\/[\S^)]+?\.(?:jpg|jpeg|png|gif|webp|svg|bmp|tiff|ico))\)/i.test(markdown)) {
        let result = markdown
          .replace(/\\\[(.*?)\\\]/gs, (_, equation) => `$$${equation}$$`)
          .replace(/\\\((.*?)\\\)/gs, (_, equation) => `$${equation}$`);
        if (disableImage) {
            // Loại bỏ các block ảnh nếu disableImage
            result = result.replace(/!\[[^\]]*\]\((https?:\/\/[\S^)]+?\.(?:jpg|jpeg|png|gif|webp|svg|bmp|tiff|ico))\)/gi, '');
        }
        // Thay thế khoảng trắng trong url ảnh thành %20
        result = result.replace(/(!?\[[^\]]*\]\()([^\s)]+(?:\s[^\s)]+)*)(\))/g, (match, p1, p2, p3) => {
            return p1 + p2.replace(/ /g, '%20') + p3;
        });
        return result;
    }
    // Nếu có markdown link ảnh thì xử lý
    return markdown
      .replace(/\\\[(.*?)\\\]/gs, (_, equation) => `$$${equation}$$`)
      .replace(/\\\((.*?)\\\)/gs, (_, equation) => `$${equation}$`)
      .replace(/(?<!!)\[([^\]]+)\]\((https?:\/\/[\S^)]+?\.(?:jpg|jpeg|png|gif|webp|svg|bmp|tiff|ico))\)/gi, '![$1]($2)')
      // Thay thế khoảng trắng trong url ảnh thành %20
      .replace(/(!?\[[^\]]*\]\()([^\s)]+(?:\s[^\s)]+)*)(\))/g, (match, p1, p2, p3) => {
        return p1 + p2.replace(/ /g, '%20') + p3;
      });
};

function formatNumberByLocale(number, locale = navigator.language) {
  return Number(number).toLocaleString(locale);
}


export { scrollToSection, groupMessagesByUID, preprocessMarkdown, formatNumberByLocale };
